import { StaticLabelKey } from '.';
export var createStaticLabelDriver = function (wrapper) {
    var base = wrapper.$("." + StaticLabelKey);
    return {
        text: function () { return base.text(); },
        hasIcon: function () { return base.$('.icon').exists(); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map